export default "__VITE_ASSET__y$HW60Gz__"